export const ADMIN_PERITO_POST = "ADMIN_PERITO_POST";
export const ADMIN_PERITO_POST_SUCCESS = "ADMIN_PERITO_POST_SUCCESS";